const SET_CONFIGURED_AUTOMATION_INTERFACE = (state, configuredAutomationInterface) => {
  state.configuredAutomationInterface = configuredAutomationInterface;
};

const SET_LOADED_AUTOMATION_INTERFACE = (state, loadedAutomationInterface) => {
  state.loadedAutomationInterface = loadedAutomationInterface;
};

const SET_AUTOMATION_INTERFACE_ID = (state, automationInterfaceId) => {
  state.automationInterfaceId = automationInterfaceId;
};

const SET_IS_GLOBAL = (state, isGlobal) => {
  state.isGlobal = isGlobal;
};

const SET_AUTOMATION_RESULTS = (state, automationResults) => {
  state.automationResults = automationResults;
};

const SET_AUTOMATION_RESULTS_PAGINATION = (state, automationResultsPagination) => {
  state.automationResultsPagination = automationResultsPagination;
};
const SET_FETCHING_AUTOMATION_RESULTS = (state, fetchingAutomationResults) => {
  state.fetchingAutomationResults = fetchingAutomationResults;
};

const SET_SEARCHABLES = (state, searchables) => {
  state.searchables = searchables;
};
const SET_SEARCHABLES_PAGINATION = (state, searchablesPagination) => {
  state.searchablesPagination = searchablesPagination;
};

const SET_CONFIGURED_AUTOMATION_INTERFACE_PENDING_CONFIRMATION_COUNT = (
  state, pendingConfirmationCount,
) => {
  state.configuredAutomationInterface.pending_confirmation = pendingConfirmationCount;
};

export default {
  SET_SEARCHABLES_PAGINATION,
  SET_SEARCHABLES,
  SET_AUTOMATION_RESULTS_PAGINATION,
  SET_FETCHING_AUTOMATION_RESULTS,
  SET_AUTOMATION_RESULTS,
  SET_LOADED_AUTOMATION_INTERFACE,
  SET_IS_GLOBAL,
  SET_AUTOMATION_INTERFACE_ID,
  SET_CONFIGURED_AUTOMATION_INTERFACE,
  SET_CONFIGURED_AUTOMATION_INTERFACE_PENDING_CONFIRMATION_COUNT,
};
